jQuery.cachedScript = function(urls, options) {

    var ret = {
        done: function(func) {
            func();
        }
    };

    if (typeof urls == 'object') {
        for (var i = 0; i < urls.length; i++) {
            processUrl(urls[i], options);
        }
    } else {
        processUrl(urls, options);
    }

    function processUrl(url, options) {
        // handling for scripts already retrieved in the same run space
        var scripts = $(document).data('cached_scripts');
        var script = null;
        if (scripts) {
            scripts = JSON.parse(scripts);
            for (var i = 0; ! script && i < scripts.length; i++) {
                if (scripts[i] == url) {
                    script = url;
                }
            }
        }

        if ( ! script) {
            // allow user to set any option except for dataType, cache, and url
            options = $.extend(options || {}, {
                dataType: "script",
                cache: true,
                url: url,
                success: function() {
                    var scripts = $(document).data('cached_scripts');
                    if ( ! scripts) {
                        scripts = [];
                    } else {
                        scripts = JSON.parse(scripts);
                    }
                    scripts.push(url);
                    $(document).data('cached_scripts', JSON.stringify(scripts));
                }
            });

            // Use $.ajax() since it is more flexible than $.getScript
            // Return the jqXHR object so we can chain callbacks
            ret = jQuery.ajax(options);
        }
    }

    return ret;

};
